import { keyBy } from "lodash";
import { IMappedData } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/IMappedData";
import { GenerateFullDateRange } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/Helpers/Data/GenerateFullDateRange";


export function FillMissingDates(
    mapped: IMappedData[],
    missingDateValue: number
): IMappedData[] {
    if (mapped.length === 0) {
        return [];
    }

    // Step 1: Find start and end dates
    const startDate = new Date(mapped[0].time);
    const endDate = new Date(mapped[mapped.length - 1].time);

    // Step 2: Generate a complete date range from startDate to endDate
    const allDates = GenerateFullDateRange(startDate, endDate);

    // Step 3: Create a map of existing data keyed by date
    const mappedByDate = keyBy(mapped, "time");

    // Step 4: Fill in missing dates with default value
    const mappedWithMissingDates = allDates.map((date) => {
        const dateString = date.toISOString().split("T")[0]; // Format date to 'YYYY-MM-DD'
        return (
            mappedByDate[dateString] || {
                time: dateString,
                value: missingDateValue,
            }
        );
    });

    return mappedWithMissingDates;
}
